import { WPBlockProps } from './types';
import * as React from 'react';
import ImageTile, { ImageTileBlock } from '../images/image-tile';

export default function WpImage({ block }: WPBlockProps): JSX.Element | null {
  const image = {
    ...block.attributes,
  };
  const className = image.className;
  return (
    <ImageTile
      image={block as unknown as ImageTileBlock}
      caption={image.caption}
      href={image.href || image.localUrl}
      linkTarget={image.linkTarget}
      styleClass={className}
      content={block.saveContent}
    />
  );
}
